var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.19 17.478l6.457 6.456a1.21 1.21 0 11-1.713 1.711l-6.456-6.456a9.6 9.6 0 111.712-1.71h0zM12.6 18.8A7.2 7.2 0 1012.602 4.4a7.2 7.2 0 000 14.4z",
    fill: "#ED1B2E",
    stroke: "#ED1B2E",
    strokeWidth: 0.7
  })));
}

export default SvgSearch;